export default __webpack_public_path__ + "static/pai-filha-cafe-b5f80b5fa9bfcbe034176719a76a661a.webp";